exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "img[data-v-bb9f2fbe]{max-width:20vw;min-width:200px}.banner-1[data-v-bb9f2fbe]{background-image:url(" + require("./../images/overview-banner-1.jpg") + ");background-size:cover;background-position-y:center;height:calc(100vh - 100px)}.banner-2[data-v-bb9f2fbe],.banner-3[data-v-bb9f2fbe]{transition:1.5s;transform:translateY(20px);opacity:0}.forkme[data-v-bb9f2fbe]{max-width:20vw;position:absolute;right:0}.forkme[data-v-bb9f2fbe]:hover{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bb9f2fbe","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/overview.vue
// module id = 373
// module chunks = 0